/** Verde livre, laranja em atendimento, cinza quando a leitura envelheceu. */
export const FLEET_COLORS = { free: '#28c76f', busy: '#ff9f43', stale: '#b4bdc6' }

export function fleetStateColor(position) {
  if (position.stale) return FLEET_COLORS.stale

  return position.team && position.team.busy ? FLEET_COLORS.busy : FLEET_COLORS.free
}

/** Rumo, em graus a partir do norte, de um ponto ao outro. */
export function bearing(from, to) {
  const rad = Math.PI / 180
  const dLng = (to.lng - from.lng) * rad
  const y = Math.sin(dLng) * Math.cos(to.lat * rad)
  const x = Math.cos(from.lat * rad) * Math.sin(to.lat * rad)
    - Math.sin(from.lat * rad) * Math.cos(to.lat * rad) * Math.cos(dLng)

  return (Math.atan2(y, x) / rad + 360) % 360
}

/** Distância em linha reta, em km. */
export function straightLineKm(a, b) {
  const dLat = (b.lat - a.lat) * 111.32
  const dLng = (b.lng - a.lng) * 111.32 * Math.cos(((a.lat + b.lat) / 2) * (Math.PI / 180))

  return Math.sqrt(dLat * dLat + dLng * dLng)
}
